module.exports = __webpack_public_path__ + "static/media/Artboard8.fb9e7518.png";